var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _line, _line2, _line3, _line4, _path12, _path13, _line5, _line6, _line7, _line8, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g, _ellipse, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _circle, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtmLillust3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_713",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 713",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 290.869,
    height: 213.248,
    viewBox: "0 0 290.869 213.248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5.559,
    y1: -0.548,
    x2: 5.559,
    y2: 0.452,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_205",
    "data-name": "\\u30D1\\u30B9 205",
    d: "M114.148,479.646c9.62-3.784,24.721-4.555,38.467-4.252,43.176.945,82.15,10.141,115.86,20.544,12.2,3.767,24.22,7.826,32.142,13.012,16.126,10.557,11.342,25.181-11.081,33.878-7.63,2.96-16.879,5.236-26.375,7.237a330.252,330.252,0,0,1-54.259,7.272,403.453,403.453,0,0,1-41.079-.705c-37.954-2.279-75.205-7.286-106.43-15.892-13.7-3.767-26.6-8.452-32.242-14.55s-2.034-13.82,11.951-17.43c5.787-1.491,12.7-2.166,19.469-2.8,9.965-.931,20.089-1.852,29.081-3.745,9.289-1.957,20.287-5.74,18.449-10.069C106.12,487.5,104.539,483.424,114.148,479.646Z",
    transform: "translate(-19.272 -344.347)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_206",
    "data-name": "\\u30D1\\u30B9 206",
    d: "M500.62,29.241l-1.05,60.9s38.006,0,70.342,10.5l.631-61.54S518.678,26.722,500.62,29.241Z",
    transform: "translate(-361.904 -20.938)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_207",
    "data-name": "\\u30D1\\u30B9 207",
    d: "M498.62,26.241l-1.05,60.9s38.006,0,70.342,10.5l.631-61.54S516.678,23.722,498.62,26.241Z",
    transform: "translate(-360.455 -18.765)",
    fill: "#f5f5fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_208",
    "data-name": "\\u30D1\\u30B9 208",
    d: "M260.823,29.072l1.05,60.9s-38.006,0-70.342,10.5L190.9,38.949S242.765,26.553,260.823,29.072Z",
    transform: "translate(-138.294 -20.816)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_209",
    "data-name": "\\u30D1\\u30B9 209",
    d: "M262.823,26.072l1.05,60.9s-38.006,0-70.342,10.5L192.9,35.949S244.765,23.553,262.823,26.072Z",
    transform: "translate(-139.743 -18.643)",
    fill: "#f5f5fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_210",
    "data-name": "\\u30D1\\u30B9 210",
    d: "M790.41,97.42v60.264s12.4-1.469,38.425,30.657l2.312-60.264S804.059,98.892,790.41,97.42Z",
    transform: "translate(-572.598 -70.574)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_211",
    "data-name": "\\u30D1\\u30B9 211",
    d: "M788.41,95.42v60.264s12.4-1.469,38.425,30.657l2.312-60.264S802.059,96.892,788.41,95.42Z",
    transform: "translate(-571.149 -69.125)",
    fill: "#f5f5fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_212",
    "data-name": "\\u30D1\\u30B9 212",
    d: "M52.975,103.91v60.267s-12.4-1.469-38.425,30.657L12.24,134.57S39.326,105.384,52.975,103.91Z",
    transform: "translate(-8.867 -75.276)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_213",
    "data-name": "\\u30D1\\u30B9 213",
    d: "M54.975,100.91v60.267s-12.4-1.469-38.425,30.657L14.24,131.57S41.326,102.384,54.975,100.91Z",
    transform: "translate(-10.316 -73.102)",
    fill: "#f5f5fb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_214",
    "data-name": "\\u30D1\\u30B9 214",
    d: "M435.518,468.471c0,2.053-13.037,13.916-42.713,13.916s-45.744-11.45-45.744-13.5,16.62,3.031,46.3,3.031S435.518,466.415,435.518,468.471Z",
    transform: "translate(-251.421 -339.042)",
    fill: "#f7f7fd"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_53",
    "data-name": "\\u6955\\u5186\\u5F62 53",
    cx: 3.158,
    cy: 0.433,
    rx: 3.158,
    ry: 0.433,
    transform: "translate(83.952 100.288)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_54",
    "data-name": "\\u6955\\u5186\\u5F62 54",
    cx: 3.158,
    cy: 0.433,
    rx: 3.158,
    ry: 0.433,
    transform: "translate(71.857 101.514)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_55",
    "data-name": "\\u6955\\u5186\\u5F62 55",
    cx: 3.158,
    cy: 0.433,
    rx: 3.158,
    ry: 0.433,
    transform: "translate(57.616 99.855)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_56",
    "data-name": "\\u6955\\u5186\\u5F62 56",
    cx: 2.243,
    cy: 0.309,
    rx: 2.243,
    ry: 0.309,
    transform: "translate(77.614 105.129)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_57",
    "data-name": "\\u6955\\u5186\\u5F62 57",
    cx: 2.243,
    cy: 0.309,
    rx: 2.243,
    ry: 0.309,
    transform: "translate(65.062 104.821)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_215",
    "data-name": "\\u30D1\\u30B9 215",
    d: "M236.675,306.58s4.426-14.514-.694-20.326a9.594,9.594,0,0,0-10.113-3.288,3.6,3.6,0,0,0-2.323,1.929c-.681,1.469-.551,3.858,4.249,6.636,8.044,4.657,8.543,11.048,8.543,11.048Z",
    transform: "translate(-161.726 -204.729)",
    fill: "#224ea8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_216",
    "data-name": "\\u30D1\\u30B9 216",
    d: "M235.24,291.37s13.051,4.081,10.124,21.558",
    transform: "translate(-170.415 -211.078)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_217",
    "data-name": "\\u30D1\\u30B9 217",
    d: "M259.382,296.68a2.885,2.885,0,0,0-1.226,3.031",
    transform: "translate(-186.935 -214.924)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_218",
    "data-name": "\\u30D1\\u30B9 218",
    d: "M239.99,298.783a2.265,2.265,0,0,1,2.433-.5",
    transform: "translate(-173.856 -215.95)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_219",
    "data-name": "\\u30D1\\u30B9 219",
    d: "M258.76,320.008s1.929-.978,2.428.248",
    transform: "translate(-187.454 -231.556)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_220",
    "data-name": "\\u30D1\\u30B9 220",
    d: "M272.154,328.371s-1.449-.116-1.474.576",
    transform: "translate(-196.089 -237.877)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_221",
    "data-name": "\\u30D1\\u30B9 221",
    d: "M252.046,342.887s-5.186-10.549-6.614-10.317c-.675.11-.987.774-1.13,1.444a4.244,4.244,0,0,0,.276,2.568A11.423,11.423,0,0,0,252.046,342.887Z",
    transform: "translate(-176.918 -240.922)",
    fill: "#224ea8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_222",
    "data-name": "\\u30D1\\u30B9 222",
    d: "M248.76,339.84s5.442,7.892,6.5,8.24",
    transform: "translate(-180.21 -246.191)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_61",
    "data-name": "\\u7DDA 61",
    x2: 1.27,
    transform: "translate(68.057 94.881)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_62",
    "data-name": "\\u7DDA 62",
    x2: 1.99,
    y2: 0.085,
    transform: "translate(69.578 97.769)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_63",
    "data-name": "\\u7DDA 63",
    x1: 0.218,
    y2: 1.036,
    transform: "translate(70.573 95.46)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_64",
    "data-name": "\\u7DDA 64",
    x1: 0.039,
    y2: 0.942,
    transform: "translate(72.869 98.615)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_223",
    "data-name": "\\u30D1\\u30B9 223",
    d: "M272.07,342.887s5.183-10.549,6.614-10.317c.678.11.989.774,1.13,1.444a4.263,4.263,0,0,1-.276,2.568A11.423,11.423,0,0,1,272.07,342.887Z",
    transform: "translate(-197.096 -240.922)",
    fill: "#224ea8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_224",
    "data-name": "\\u30D1\\u30B9 224",
    d: "M278.842,339.84s-5.443,7.892-6.492,8.24",
    transform: "translate(-197.299 -246.191)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_65",
    "data-name": "\\u7DDA 65",
    x1: 1.27,
    transform: "translate(80.775 94.881)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_66",
    "data-name": "\\u7DDA 66",
    x1: 1.992,
    y2: 0.085,
    transform: "translate(78.532 97.769)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_67",
    "data-name": "\\u7DDA 67",
    x2: 0.218,
    y2: 1.036,
    transform: "translate(79.311 95.46)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_68",
    "data-name": "\\u7DDA 68",
    x2: 0.039,
    y2: 0.942,
    transform: "translate(77.195 98.615)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_225",
    "data-name": "\\u30D1\\u30B9 225",
    d: "M238.95,375.209a.9.9,0,0,1-.295-.446.391.391,0,0,1,.207-.452c.187-.074.391.058.551.19a.728.728,0,0,0,.529.256.81.81,0,0,1-.251-.755.347.347,0,0,1,.072-.154c.1-.113.295-.063.422.025a1.568,1.568,0,0,1,.513,1.314,2.363,2.363,0,0,0,0-.551.551.551,0,0,1,.2-.48.625.625,0,0,1,.309-.074.644.644,0,0,1,.5.143.507.507,0,0,1-.019.62,1.971,1.971,0,0,1-.521.416,1.122,1.122,0,0,0-.372.355.253.253,0,0,0-.028.063h-1.13A3.276,3.276,0,0,1,238.95,375.209Z",
    transform: "translate(-172.88 -270.78)",
    fill: "#224ea8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_226",
    "data-name": "\\u30D1\\u30B9 226",
    d: "M310.65,359.794a.894.894,0,0,1-.295-.444.394.394,0,0,1,.207-.455.579.579,0,0,1,.551.193.713.713,0,0,0,.529.254.808.808,0,0,1-.251-.755.308.308,0,0,1,.072-.152c.1-.113.295-.066.422.022a1.57,1.57,0,0,1,.513,1.317,2.391,2.391,0,0,0,0-.551.551.551,0,0,1,.2-.48.591.591,0,0,1,.309-.072.634.634,0,0,1,.5.143.5.5,0,0,1-.019.617,1.971,1.971,0,0,1-.521.416,1.15,1.15,0,0,0-.372.355.253.253,0,0,0-.028.063h-1.13A3.183,3.183,0,0,1,310.65,359.794Z",
    transform: "translate(-224.821 -259.613)",
    fill: "#224ea8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_227",
    "data-name": "\\u30D1\\u30B9 227",
    d: "M286.752,375.209a.9.9,0,0,1-.295-.446.394.394,0,0,1,.207-.452c.19-.074.391.058.551.19a.73.73,0,0,0,.529.256A.808.808,0,0,1,287.5,374a.314.314,0,0,1,.069-.154c.1-.113.295-.063.422.025a1.57,1.57,0,0,1,.515,1.314,2.528,2.528,0,0,0,0-.551.551.551,0,0,1,.2-.48.827.827,0,0,1,.813.069.5.5,0,0,1-.019.62,1.934,1.934,0,0,1-.521.416,1.173,1.173,0,0,0-.372.355.445.445,0,0,0-.028.063h-1.127A3.219,3.219,0,0,1,286.752,375.209Z",
    transform: "translate(-207.509 -270.78)",
    fill: "#224ea8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_228",
    "data-name": "\\u30D1\\u30B9 228",
    d: "M217.275,347.8s-.422.551.2,1.378,1.13,1.54.923,2.061c0,0-.934-1.551-1.692-1.573S216.448,348.731,217.275,347.8Z",
    transform: "translate(-156.716 -251.957)",
    fill: "#224ea8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_229",
    "data-name": "\\u30D1\\u30B9 229",
    d: "M217.28,347.8a.648.648,0,0,0-.085.174c-.741.868-1.135,1.681-.424,1.7.664.019,1.461,1.207,1.653,1.5a.5.5,0,0,1-.022.069s-.934-1.551-1.692-1.573S216.453,348.731,217.28,347.8Z",
    transform: "translate(-156.721 -251.957)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_230",
    "data-name": "\\u30D1\\u30B9 230",
    d: "M216.94,350.023c0,.2.022.353.05.353s.047-.157.047-.353-.025-.1-.052-.1S216.94,349.83,216.94,350.023Z",
    transform: "translate(-157.158 -253.478)",
    fill: "#ffd037"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_231",
    "data-name": "\\u30D1\\u30B9 231",
    d: "M215.7,350.851c.171.094.32.149.333.124s-.116-.118-.276-.209-.1-.028-.116,0S215.531,350.771,215.7,350.851Z",
    transform: "translate(-156.19 -254.071)",
    fill: "#ffd037"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_232",
    "data-name": "\\u30D1\\u30B9 232",
    d: "M224.843,347.8s.424.551-.2,1.378-1.127,1.54-.92,2.061c0,0,.931-1.551,1.692-1.573S225.678,348.731,224.843,347.8Z",
    transform: "translate(-162.041 -251.957)",
    fill: "#224ea8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_233",
    "data-name": "\\u30D1\\u30B9 233",
    d: "M224.894,347.8a.648.648,0,0,1,.085.174c.741.868,1.135,1.681.424,1.7-.664.019-1.458,1.207-1.653,1.5a.5.5,0,0,0,.022.069s.931-1.551,1.692-1.573S225.729,348.731,224.894,347.8Z",
    transform: "translate(-162.092 -251.957)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_234",
    "data-name": "\\u30D1\\u30B9 234",
    d: "M230.506,350.023c0,.2-.019.353-.047.353s-.05-.157-.05-.353.028-.1.055-.1S230.506,349.83,230.506,350.023Z",
    transform: "translate(-166.916 -253.478)",
    fill: "#ffd037"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_235",
    "data-name": "\\u30D1\\u30B9 235",
    d: "M230.889,350.851c-.171.094-.32.149-.331.124s.113-.118.276-.209.1-.028.118,0S231.051,350.771,230.889,350.851Z",
    transform: "translate(-167.023 -254.071)",
    fill: "#ffd037"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_236",
    "data-name": "\\u30D1\\u30B9 236",
    d: "M218.7,358.378a4.339,4.339,0,0,1-1.54-.289c-.355-.254-1.819-.551-1.907-.152s-1.777,2.025-.444,2.036a11.368,11.368,0,0,0,3.458-.424C218.621,359.334,218.7,358.378,218.7,358.378Z",
    transform: "translate(-155.243 -259.159)",
    fill: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_237",
    "data-name": "\\u30D1\\u30B9 237",
    d: "M214.787,361.5a11.642,11.642,0,0,0,3.458-.424c.276-.165.378-.758.413-1.031h.041s-.077.953-.433,1.171a11.265,11.265,0,0,1-3.458.424c-.383,0-.518-.141-.51-.344C214.351,361.418,214.5,361.492,214.787,361.5Z",
    transform: "translate(-155.245 -260.824)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_58",
    "data-name": "\\u6955\\u5186\\u5F62 58",
    cx: 9.568,
    cy: 1.414,
    rx: 9.568,
    ry: 1.414,
    transform: "translate(44.215 135.376)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_59",
    "data-name": "\\u6955\\u5186\\u5F62 59",
    cx: 9.568,
    cy: 1.414,
    rx: 9.568,
    ry: 1.414,
    transform: "translate(70.94 147.082)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_60",
    "data-name": "\\u6955\\u5186\\u5F62 60",
    cx: 9.568,
    cy: 1.414,
    rx: 9.568,
    ry: 1.414,
    transform: "translate(31.627 160.4)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_61",
    "data-name": "\\u6955\\u5186\\u5F62 61",
    cx: 9.568,
    cy: 1.414,
    rx: 9.568,
    ry: 1.414,
    transform: "translate(234.349 189.655)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_62",
    "data-name": "\\u6955\\u5186\\u5F62 62",
    cx: 6.335,
    cy: 0.708,
    rx: 6.335,
    ry: 0.708,
    transform: "translate(128.994 157.832)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_63",
    "data-name": "\\u6955\\u5186\\u5F62 63",
    cx: 6.335,
    cy: 0.708,
    rx: 6.335,
    ry: 0.708,
    transform: "translate(219.656 121.457)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_64",
    "data-name": "\\u6955\\u5186\\u5F62 64",
    cx: 6.335,
    cy: 0.708,
    rx: 6.335,
    ry: 0.708,
    transform: "translate(170.326 175.193)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_65",
    "data-name": "\\u6955\\u5186\\u5F62 65",
    cx: 6.335,
    cy: 0.708,
    rx: 6.335,
    ry: 0.708,
    transform: "translate(115.642 170.519)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_66",
    "data-name": "\\u6955\\u5186\\u5F62 66",
    cx: 6.335,
    cy: 0.708,
    rx: 6.335,
    ry: 0.708,
    transform: "translate(64.395 168.681)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_67",
    "data-name": "\\u6955\\u5186\\u5F62 67",
    cx: 6.335,
    cy: 0.708,
    rx: 6.335,
    ry: 0.708,
    transform: "translate(51.041 181.368)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_712",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 712",
    transform: "translate(97.615 47.29)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_68",
    "data-name": "\\u6955\\u5186\\u5F62 68",
    cx: 41.919,
    cy: 18.708,
    rx: 41.919,
    ry: 18.708,
    transform: "translate(0.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_238",
    "data-name": "\\u30D1\\u30B9 238",
    d: "M439.472,263.1c-1.855,9.755-20.18,17.413-42.517,17.413-22.533,0-40.985-7.793-42.567-17.667h-.157v15.9c7.369,7.7,23.682,13.054,42.619,13.054s35.251-5.354,42.622-13.054Z",
    transform: "translate(-354.23 -237.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_239",
    "data-name": "\\u30D1\\u30B9 239",
    d: "M439.472,333.3c-1.855,9.752-20.18,17.413-42.517,17.413-22.533,0-40.985-7.793-42.567-17.669h-.157v15.9c7.369,7.7,23.682,13.051,42.619,13.051s35.251-5.352,42.622-13.051Z",
    transform: "translate(-354.23 -288.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_240",
    "data-name": "\\u30D1\\u30B9 240",
    d: "M439.472,410.514c-1.855,9.755-20.18,17.413-42.517,17.413-22.533,0-40.985-7.79-42.567-17.667h-.157v17.146a2.643,2.643,0,0,0,.849,1.945c7.716,7.085,23.531,9.86,41.771,9.86s34.046-2.775,41.773-9.86a2.643,2.643,0,0,0,.849-1.945Z",
    transform: "translate(-354.23 -344.496)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_69",
    "data-name": "\\u6955\\u5186\\u5F62 69",
    cx: 41.919,
    cy: 18.708,
    rx: 41.919,
    ry: 18.708,
    transform: "translate(98.29 46.188)",
    fill: "#224ea8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_241",
    "data-name": "\\u30D1\\u30B9 241",
    d: "M439.472,259.1c-1.855,9.755-20.18,17.413-42.517,17.413-22.533,0-40.985-7.793-42.567-17.667h-.157v15.9c7.369,7.7,23.682,13.054,42.619,13.054s35.251-5.354,42.622-13.054Z",
    transform: "translate(-256.615 -187.519)",
    fill: "#224ea8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_242",
    "data-name": "\\u30D1\\u30B9 242",
    d: "M439.472,329.3c-1.855,9.752-20.18,17.413-42.517,17.413-22.533,0-40.985-7.793-42.567-17.669h-.157v15.9c7.369,7.7,23.682,13.051,42.619,13.051s35.251-5.352,42.622-13.051Z",
    transform: "translate(-256.615 -238.367)",
    fill: "#224ea8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_243",
    "data-name": "\\u30D1\\u30B9 243",
    d: "M439.472,406.514c-1.855,9.755-20.18,17.413-42.517,17.413-22.533,0-40.985-7.79-42.567-17.667h-.157v17.146a2.643,2.643,0,0,0,.849,1.946c7.716,7.085,23.531,9.86,41.771,9.86s34.046-2.775,41.773-9.86a2.643,2.643,0,0,0,.849-1.946Z",
    transform: "translate(-256.615 -294.308)",
    fill: "#224ea8"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_70",
    "data-name": "\\u6955\\u5186\\u5F62 70",
    cx: 15.707,
    cy: 2.827,
    rx: 15.707,
    ry: 2.827,
    transform: "translate(186.293 154.591)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_244",
    "data-name": "\\u30D1\\u30B9 244",
    d: "M699.877,333.395a3.243,3.243,0,0,0,3.607-.234l-.014,2.235a57.584,57.584,0,0,0,2.006,7.118l1.337,4.594a35.84,35.84,0,0,1,1.469,10,9.57,9.57,0,0,0,.427,3.147c.714,1.929-.276,4.409-.708,5.324a22.055,22.055,0,0,1-2.2.62,1.576,1.576,0,0,0-.2.061v-.014a9.091,9.091,0,0,1-2.9.686.779.779,0,0,0-.551,1.359,4.108,4.108,0,0,1-1.334.176c-.893-.11-1.339,1.422.333,1.86s11.15,0,11.15,0a1.342,1.342,0,0,0,.711-1.483l1.185-.05s1.673-.766,0-2.847l-.091.066-.356-1.053v-1.419s2.119-10.2,1.45-11.389-1.025-7.349-1.025-7.349l.234-6.669a15.828,15.828,0,0,0,1.069-4.732,9.932,9.932,0,0,0,.427-2.243c.027-.361.05-.736.063-1.127a7.51,7.51,0,0,0-.408-2.524,25.382,25.382,0,0,1,2.527-3.169,3.258,3.258,0,0,0,1.006-2.847l-.551-3.723-1.339-6.338a4.847,4.847,0,0,0-.606-3.348c.1-.57.187-1.138.256-1.711a21.931,21.931,0,0,0-.391-7.44,5.028,5.028,0,0,0-1.055-2.367c-.675-.733-1.772-1.177-2.026-2.133a5.693,5.693,0,0,0-.154-.722c-.245-.626-1.017-.854-1.695-.937a9.206,9.206,0,0,0-4.111.218,4.985,4.985,0,0,0-2.381,2.21,1.9,1.9,0,0,0-.276,1.364,1.821,1.821,0,0,0,.19.468,4.241,4.241,0,0,0,2.464,5.429c.028.085.052.168.072.248a4.232,4.232,0,0,1,.11.6c-.022.386-.047.774-.063,1.163l-.041.157a28.947,28.947,0,0,0-2.8,1.427c.667.987-.113,5.148-.113,5.148a4.239,4.239,0,0,0-1.56,6.131,6.56,6.56,0,0,1,.78,5.473l-.276,4.282h0l-.055.857h.019l-.019.325h.047v.35a5.2,5.2,0,0,0-2.61,1.943,6.867,6.867,0,0,1-1.166,1.43.86.86,0,0,0,.138,1.4Zm13.462-11.375a4.07,4.07,0,0,1,.4-2.155h.788a5.077,5.077,0,0,0,.1.518C714.846,321.36,713.942,321.821,713.339,322.019Z",
    transform: "translate(-506.696 -212.001)",
    fill: "url(#linear-gradient)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_245",
    "data-name": "\\u30D1\\u30B9 245",
    d: "M727.274,551.016l.43,1.287-1.394,1.394-4.613,1.086-3.326-.322.215-1.179h0a1.425,1.425,0,0,1,1.055-1.042c1.378-.32,3.974-1.053,4.522-2.069Z",
    transform: "translate(-520.41 -398.56)",
    fill: "#db8b8b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_246",
    "data-name": "\\u30D1\\u30B9 246",
    d: "M727.274,551.016l.43,1.287-1.394,1.394-4.613,1.086-3.326-.322.215-1.179h0a1.425,1.425,0,0,1,1.055-1.042c1.378-.32,3.974-1.053,4.522-2.069Z",
    transform: "translate(-520.41 -398.56)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_247",
    "data-name": "\\u30D1\\u30B9 247",
    d: "M712.917,558.887l.645-.857-.645-.995a8.625,8.625,0,0,1-2.789.672c-.86-.107-1.287,1.394.322,1.824s10.728,0,10.728,0,1.609-.752,0-2.792l-1.394,1.075s-2.362,1.287-3.541,1.072Z",
    transform: "translate(-513.885 -403.32)",
    fill: "#c17174"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_248",
    "data-name": "\\u30D1\\u30B9 248",
    d: "M711.76,559.871l3.326.322,4.613-1.075,1.394-1.394-.113-.339-.16-.479-.157-.469-3.117-.857a1.929,1.929,0,0,1-.631.631,13.257,13.257,0,0,1-3.891,1.438,1.033,1.033,0,0,0-.132.041,1.379,1.379,0,0,0-.551.333,1.406,1.406,0,0,0-.38.667Z",
    transform: "translate(-515.621 -402.48)",
    fill: "#db8b8b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_249",
    "data-name": "\\u30D1\\u30B9 249",
    d: "M711.76,564.616l3.326.322,4.613-1.075,1.394-1.394-.113-.339-1.281.984s-2.362,1.287-3.541,1.072h-3.329l.645-.857-.579-.893a1.379,1.379,0,0,0-.551.333,1.407,1.407,0,0,0-.38.667Z",
    transform: "translate(-515.621 -407.225)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_250",
    "data-name": "\\u30D1\\u30B9 250",
    d: "M706.3,564.344l.645-.857-.645-.995a8.625,8.625,0,0,1-2.789.672c-.86-.107-1.287,1.394.323,1.824s10.728,0,10.728,0,1.609-.752,0-2.789l-1.394,1.072s-2.362,1.287-3.541,1.072Z",
    transform: "translate(-509.089 -407.275)",
    fill: "#c17174"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_251",
    "data-name": "\\u30D1\\u30B9 251",
    d: "M725.37,329.235s5.15.551,4.409-1.609a3.831,3.831,0,0,1-.16-1.9,5.22,5.22,0,0,1,.909-2.18l-4.828.75a6.026,6.026,0,0,1,.656,1.551A3.172,3.172,0,0,1,725.37,329.235Z",
    transform: "translate(-525.481 -234.39)",
    fill: "#db8b8b"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_252",
    "data-name": "\\u30D1\\u30B9 252",
    d: "M740.913,432.91s-.107,4.613-1.179,6.867l-.215,6.545s.32,6.007.964,7.187-1.394,11.158-1.394,11.158v1.717s-3.434,1.287-4.409-.215l.964-12.767-.43-17.7Z",
    transform: "translate(-532.225 -313.614)",
    fill: "#474463"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_253",
    "data-name": "\\u30D1\\u30B9 253",
    d: "M740.913,432.91s-.107,4.613-1.179,6.867l-.215,6.545s.32,6.007.964,7.187-1.394,11.158-1.394,11.158v1.717s-3.434,1.287-4.409-.215l.964-12.767-.43-17.7Z",
    transform: "translate(-532.225 -313.614)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_254",
    "data-name": "\\u30D1\\u30B9 254",
    d: "M752.431,379.22l.645,1.717.551,3.646a3.238,3.238,0,0,1-.967,2.792,30.714,30.714,0,0,0-3,3.968l-2.036-6.115s2.036-.322,1.714-1.717a19.818,19.818,0,0,1-.212-3.968Z",
    transform: "translate(-541.599 -274.719)",
    fill: "#ff748e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_255",
    "data-name": "\\u30D1\\u30B9 255",
    d: "M752.478,379.13l.642,1.717.551,3.649a3.224,3.224,0,0,1-.964,2.789,30.4,30.4,0,0,0-3,3.971l-2.053-6.123s2.039-.322,1.717-1.717a19.926,19.926,0,0,1-.215-3.971Z",
    transform: "translate(-541.621 -274.654)",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_256",
    "data-name": "\\u30D1\\u30B9 256",
    d: "M730.48,556.222a2.677,2.677,0,0,0,3.9.694l-.157-.469-3.114-.868A1.928,1.928,0,0,1,730.48,556.222Z",
    transform: "translate(-529.183 -402.48)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_257",
    "data-name": "\\u30D1\\u30B9 257",
    d: "M714.86,416.827a57.423,57.423,0,0,0,1.929,6.972l1.287,4.5a35.931,35.931,0,0,1,1.414,9.794,9.567,9.567,0,0,0,.411,3.084c.86,2.362-.857,5.578-.857,5.578,1.5,2.684,4.076.86,4.076.86V445.9s2.039-9.334,1.5-11.158a44.365,44.365,0,0,1-.75-6.757v-8.906a10.106,10.106,0,0,0,2.943-6.4c.025-.353.047-.722.061-1.1.085-2.419-1.571-5.258-2.2-6.269-.154-.245-.253-.383-.253-.383l-9.471,3.759h-.022v1.182Z",
    transform: "translate(-517.867 -293.337)",
    fill: "#474463"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_258",
    "data-name": "\\u30D1\\u30B9 258",
    d: "M726.54,324.3a6.028,6.028,0,0,1,.656,1.551,4.193,4.193,0,0,0,3.263-.121,5.219,5.219,0,0,1,.909-2.18Z",
    transform: "translate(-526.328 -234.39)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_71",
    "data-name": "\\u6955\\u5186\\u5F62 71",
    cx: 4.183,
    cy: 4.183,
    r: 4.183,
    transform: "translate(198.175 83.153)",
    fill: "#db8b8b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_259",
    "data-name": "\\u30D1\\u30B9 259",
    d: "M714.86,409.824h.047c4.5.926,10.146-3.762,10.146-3.762a5.574,5.574,0,0,1-.391-.8c-.154-.245-.254-.383-.254-.383l-9.471,3.759-.025.375Z",
    transform: "translate(-517.867 -293.308)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_260",
    "data-name": "\\u30D1\\u30B9 260",
    d: "M713,337.193s6.007-3.649,7.936-2.147l2.684,3.434s1.717.537,1.4,3.982l1.287,6.222-3.858.965a4.227,4.227,0,0,0-.427,5.258s-5.688,4.72-10.2,3.753l.322-5.04a6.543,6.543,0,0,0-.75-5.365,4.194,4.194,0,0,1,1.5-6.007C712.892,342.236,713.642,338.158,713,337.193Z",
    transform: "translate(-514.824 -242.456)",
    fill: "#ff748e"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_261",
    "data-name": "\\u30D1\\u30B9 261",
    d: "M705.551,423.21a5.54,5.54,0,0,0-3.326,2.147,6.7,6.7,0,0,1-1.124,1.4.849.849,0,0,0,.135,1.356c.851.513,2.238.827,3.993-.615C708.246,425.034,705.551,423.21,705.551,423.21Z",
    transform: "translate(-507.698 -306.587)",
    fill: "#db8b8b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_262",
    "data-name": "\\u30D1\\u30B9 262",
    d: "M720.459,350.978s2.144-.215,2.681,5.363,1.394,6.867,1.394,6.867.537,2.9-.752,4.613-3.753,5.365-3.753,5.365a2.485,2.485,0,0,1-3.219-1.929l3.326-6.222a4.473,4.473,0,0,0-.752-3.649C718.1,359.884,717.132,349.9,720.459,350.978Z",
    transform: "translate(-519.28 -254.201)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_263",
    "data-name": "\\u30D1\\u30B9 263",
    d: "M719.715,349.809s2.144-.215,2.681,5.365,1.394,6.864,1.394,6.864.551,2.9-.75,4.613-3.742,5.365-3.742,5.365a2.485,2.485,0,0,1-3.219-1.929l3.326-6.222a4.462,4.462,0,0,0-.752-3.649C717.364,358.715,716.389,348.737,719.715,349.809Z",
    transform: "translate(-518.751 -253.354)",
    fill: "#ff748e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_264",
    "data-name": "\\u30D1\\u30B9 264",
    d: "M722.788,364.62s-.212,3.326.752,5.15.965,4.183,0,5.47",
    transform: "translate(-523.596 -264.142)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_265",
    "data-name": "\\u30D1\\u30B9 265",
    d: "M720.9,345.031s.857-.857,3.326-.965a7.1,7.1,0,0,0,3.538-.857",
    transform: "translate(-522.243 -248.632)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_266",
    "data-name": "\\u30D1\\u30B9 266",
    d: "M725.724,296.992c.653.08,1.4.3,1.631.915a6.105,6.105,0,0,1,.152.708c.242.937,1.3,1.378,1.948,2.089a5.014,5.014,0,0,1,1.014,2.323,21.812,21.812,0,0,1,.378,7.289c-.209,1.777-.639,3.53-.758,5.316a8.444,8.444,0,0,0,1.075,5.17,12.471,12.471,0,0,1,1.273,1.929,3.717,3.717,0,0,1-2.257.6q-1.378.047-2.769,0a2.94,2.94,0,0,1-1.405-.295,2.164,2.164,0,0,1-.738-.791,5.661,5.661,0,0,1-.639-3.012c.022-1.039.187-2.072.207-3.114a2.706,2.706,0,0,0-.361-1.631,5.25,5.25,0,0,0-.9-.827,5.694,5.694,0,0,1-1.582-4.186c-.039-1.535.215-3.07.085-4.6-.05-.6-.276-1.317-.862-1.433a3.123,3.123,0,0,1-.551-.072c-.471-.182-.424-.846-.551-1.334-.152-.551-.62-.973-.752-1.524-.309-1.3,1.345-2.849,2.428-3.307A8.683,8.683,0,0,1,725.724,296.992Z",
    transform: "translate(-521.1 -215.062)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_267",
    "data-name": "\\u30D1\\u30B9 267",
    d: "M726.114,296.224c.653.08,1.4.3,1.631.918a5.912,5.912,0,0,1,.152.705c.242.937,1.3,1.378,1.948,2.089a5.015,5.015,0,0,1,1.014,2.323,21.818,21.818,0,0,1,.375,7.3c-.207,1.777-.637,3.53-.755,5.318a8.432,8.432,0,0,0,1.075,5.167,12.611,12.611,0,0,1,1.273,1.929,3.7,3.7,0,0,1-2.257.6q-1.378.044-2.769,0a2.936,2.936,0,0,1-1.405-.292,2.174,2.174,0,0,1-.739-.794,5.662,5.662,0,0,1-.639-3.012c.022-1.039.187-2.072.207-3.111a2.778,2.778,0,0,0-.361-1.631,5.17,5.17,0,0,0-.9-.827,5.694,5.694,0,0,1-1.582-4.186c-.039-1.535.215-3.07.085-4.6-.05-.6-.276-1.317-.863-1.433a3.123,3.123,0,0,1-.551-.072c-.471-.182-.424-.846-.551-1.334-.152-.551-.62-.97-.752-1.524-.309-1.3,1.345-2.849,2.428-3.307A8.69,8.69,0,0,1,726.114,296.224Z",
    transform: "translate(-521.383 -214.509)",
    fill: "#464353"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_268",
    "data-name": "\\u30D1\\u30B9 268",
    d: "M128.04,568.573s2.954-.091,3.841-.725,4.541-1.392,4.762-.375,4.437,5.054,1.1,5.081-7.743-.521-8.634-1.061S128.04,568.573,128.04,568.573Z",
    transform: "translate(-92.756 -410.736)",
    fill: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_269",
    "data-name": "\\u30D1\\u30B9 269",
    d: "M137.806,576.362c-3.332.028-7.743-.518-8.631-1.058-.675-.413-.945-1.89-1.036-2.574h-.1s.187,2.381,1.075,2.921,5.3,1.086,8.634,1.061c.962,0,1.292-.35,1.276-.857C138.889,576.172,138.523,576.362,137.806,576.362Z",
    transform: "translate(-92.756 -414.904)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_270",
    "data-name": "\\u30D1\\u30B9 270",
    d: "M808.93,429.238a7.43,7.43,0,0,0,2.637-.5c.612-.435,3.117-.953,3.268-.256s3.048,3.469.758,3.489-5.316-.358-5.925-.728S808.93,429.238,808.93,429.238Z",
    transform: "translate(-586.014 -310.16)",
    fill: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_271",
    "data-name": "\\u30D1\\u30B9 271",
    d: "M815.635,434.6c-2.287.017-5.316-.358-5.925-.727-.466-.276-.65-1.3-.711-1.766h-.069s.13,1.634.739,2.006,3.638.744,5.925.727c.661,0,.89-.24.876-.59C816.379,434.469,816.128,434.6,815.635,434.6Z",
    transform: "translate(-586.014 -313.034)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_72",
    "data-name": "\\u6955\\u5186\\u5F62 72",
    cx: 5.961,
    cy: 5.961,
    r: 5.961,
    transform: "translate(2.662)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_73",
    "data-name": "\\u6955\\u5186\\u5F62 73",
    cx: 5.961,
    cy: 5.961,
    r: 5.961,
    transform: "translate(258.941 17.085)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_74",
    "data-name": "\\u6955\\u5186\\u5F62 74",
    cx: 4.409,
    cy: 4.409,
    r: 4.409,
    transform: "translate(0 24.851)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_75",
    "data-name": "\\u6955\\u5186\\u5F62 75",
    cx: 4.409,
    cy: 4.409,
    r: 4.409,
    transform: "translate(44.642 0.05)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_76",
    "data-name": "\\u6955\\u5186\\u5F62 76",
    cx: 4.409,
    cy: 4.409,
    r: 4.409,
    transform: "translate(225.415 0.601)",
    fill: "#224ea8",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_272",
    "data-name": "\\u30D1\\u30B9 272",
    d: "M881.637,646.4s1.1,1.444-.51,3.624-2.943,4.018-2.406,5.376c0,0,2.433-4.045,4.409-4.1S883.814,648.836,881.637,646.4Z",
    transform: "translate(-636.486 -468.273)",
    fill: "#fc6681"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_273",
    "data-name": "\\u30D1\\u30B9 273",
    d: "M881.789,646.4a1.759,1.759,0,0,1,.223.455c1.929,2.271,2.965,4.39,1.1,4.442-1.731.05-3.806,3.144-4.3,3.927a1.46,1.46,0,0,0,.061.176s2.433-4.045,4.409-4.1S883.966,648.836,881.789,646.4Z",
    transform: "translate(-636.638 -468.273)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_274",
    "data-name": "\\u30D1\\u30B9 274",
    d: "M896.394,652.214c0,.507-.058.92-.127.92s-.127-.413-.127-.92.072-.276.141-.276S896.394,651.7,896.394,652.214Z",
    transform: "translate(-649.192 -472.246)",
    fill: "#ffd037"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_275",
    "data-name": "\\u30D1\\u30B9 275",
    d: "M897.321,654.367c-.446.242-.827.389-.871.328s.3-.309.747-.551.276-.066.306,0S897.767,654.125,897.321,654.367Z",
    transform: "translate(-649.414 -473.793)",
    fill: "#ffd037"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_276",
    "data-name": "\\u30D1\\u30B9 276",
    d: "M861.97,646.4s-1.1,1.444.51,3.624,2.943,4.018,2.406,5.376c0,0-2.436-4.045-4.409-4.1S859.79,648.836,861.97,646.4Z",
    transform: "translate(-622.649 -468.273)",
    fill: "#fc6681"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_277",
    "data-name": "\\u30D1\\u30B9 277",
    d: "M861.975,646.4a1.818,1.818,0,0,0-.226.455c-1.929,2.271-2.962,4.39-1.1,4.442,1.731.05,3.808,3.144,4.3,3.927-.017.058-.036.118-.058.176,0,0-2.436-4.045-4.409-4.1S859.8,648.836,861.975,646.4Z",
    transform: "translate(-622.655 -468.273)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_278",
    "data-name": "\\u30D1\\u30B9 278",
    d: "M861.01,652.214c0,.507.058.92.129.92s.127-.413.127-.92-.072-.276-.143-.276S861.01,651.7,861.01,652.214Z",
    transform: "translate(-623.743 -472.246)",
    fill: "#ffd037"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_279",
    "data-name": "\\u30D1\\u30B9 279",
    d: "M857.752,654.367c.446.242.827.389.868.328s-.3-.309-.747-.551-.276-.066-.3,0S857.306,654.125,857.752,654.367Z",
    transform: "translate(-621.188 -473.793)",
    fill: "#ffd037"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_280",
    "data-name": "\\u30D1\\u30B9 280",
    d: "M862.29,674s3.086-.1,4.015-.758,4.748-1.452,4.98-.391,4.635,5.283,1.152,5.31-8.1-.551-9.022-1.1S862.29,674,862.29,674Z",
    transform: "translate(-624.67 -487.056)",
    fill: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_281",
    "data-name": "\\u30D1\\u30B9 281",
    d: "M872.5,682.172c-3.486.028-8.1-.551-9.025-1.1-.705-.43-.989-1.976-1.083-2.69h-.1s.2,2.48,1.124,3.053,5.539,1.135,9.022,1.1c1.006,0,1.353-.367,1.334-.9C873.632,681.965,873.247,682.166,872.5,682.172Z",
    transform: "translate(-624.67 -491.44)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_282",
    "data-name": "\\u30D1\\u30B9 282",
    d: "M301.237,125.97a5.787,5.787,0,1,0,5.787,5.787A5.787,5.787,0,0,0,301.237,125.97Zm0,1.122a4.685,4.685,0,1,1-4.685,4.685,4.685,4.685,0,0,1,4.685-4.685m3.277,3.045-.526-.532a.276.276,0,0,0-.39-.007l-.007.007-3.307,3.277-1.394-1.416a.276.276,0,0,0-.39-.007l-.007.007-.529.526a.276.276,0,0,0-.007.39l.007.007,2.122,2.138a.276.276,0,0,0,.39.007l.007-.007,4.032-4a.276.276,0,0,0,.007-.39l-.007-.007Z",
    transform: "translate(-214.033 -91.257)",
    fill: "#3acc6c",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_283",
    "data-name": "\\u30D1\\u30B9 283",
    d: "M72.2,231.892a5.779,5.779,0,1,0,.015,0Zm.254,1.1a4.685,4.685,0,1,1-3.5,5.627l0-.022a4.685,4.685,0,0,1,3.5-5.605m3.877,2.232-.634-.408a.275.275,0,0,0-.381.081l0,.007-2.48,3.935-1.678-1.061a.275.275,0,0,0-.381.081l0,.007-.4.634a.275.275,0,0,0,.081.381l.007,0L73,240.5a.275.275,0,0,0,.382-.078l.007-.01,3.031-4.8a.276.276,0,0,0-.079-.382l-.007,0Z",
    transform: "translate(-49.056 -167.88)",
    fill: "#3acc6c",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_284",
    "data-name": "\\u30D1\\u30B9 284",
    d: "M607.307,129.01a5.787,5.787,0,1,0,5.787,5.787h0A5.787,5.787,0,0,0,607.307,129.01Zm0,1.122a4.685,4.685,0,1,1-4.685,4.685,4.685,4.685,0,0,1,4.685-4.685m3.276,3.045-.526-.532a.276.276,0,0,0-.39-.007l-.007.007-3.307,3.277-1.4-1.408a.276.276,0,0,0-.39-.007l-.007.007-.526.532a.276.276,0,0,0-.007.39l.007.007,2.122,2.138a.276.276,0,0,0,.39.007l.007-.007,4.032-4a.276.276,0,0,0,.007-.39l-.007-.007Z",
    transform: "translate(-435.76 -93.459)",
    fill: "#3acc6c",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_285",
    "data-name": "\\u30D1\\u30B9 285",
    d: "M847.059,232.674a5.759,5.759,0,1,0,.008,0Zm-.088,1.116a4.685,4.685,0,1,1-5.023,4.32l0-.021a4.671,4.671,0,0,1,5.015-4.3h.006M850,237.08l-.485-.57a.276.276,0,0,0-.388-.038l-.006.005-3.547,3.012-1.284-1.513a.275.275,0,0,0-.387-.041l-.009.008-.57.485a.276.276,0,0,0-.035.388l.005.006,1.948,2.3a.276.276,0,0,0,.388.038l.006-.005,4.332-3.676a.276.276,0,0,0,.038-.388Z",
    transform: "translate(-609.119 -168.543)",
    fill: "#3acc6c",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmLillust3);
export default __webpack_public_path__ + "static/media/HTMLillust_3.0da7e27422d7f26a7b494258e6f38f8c.svg";
export { ForwardRef as ReactComponent };